import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <>
      <div className="contactContact">
        <div className="createdContact">
          <h3>Created by :</h3>
          <a href="https://www.linkedin.com/in/martin-gilbert-23452b1a3/">Martin Gilbert</a>
          <a href="https://www.linkedin.com/in/victor-veyrier-ab6948194/">Victor Veyrier</a>
          <a href="https://www.linkedin.com/in/brian-lagaude-4110b31a4/">Brian Lagaude</a>
          <a href="https://www.linkedin.com/in/victor-auxietre-fontes-6a8439184/">Victor Auxietre-Fontes</a>
        </div>
      </div>
    </>
  );
}

export default Contact;
